import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import {
  DomSanitizer,
  SafeHtml
} from '@angular/platform-browser';

import sprite from 'icons/workshop.sprite.svg';

import { IconSizeModel }  from './typings/icon.size';
import { IconThemeModel } from './typings/icon.theme';

@Component({
  selector   : 'wor-icon',
  styles: [ require('./icon.component.scss') ],
  template: require('./icon.component.html')
})
export class IconComponent implements OnChanges {
  public sprite: string = sprite;

  @Input() icon  : string | SafeHtml = '';
  @Input() theme : IconThemeModel    = 'workshop';
  @Input() size  : IconSizeModel     = 'md';

  constructor (
    private sanitizer : DomSanitizer
  ) {}

  ngOnChanges ( changes: SimpleChanges ) : void {
    if (changes.icon) {
      this._updateIcon();
    }
  }

  private _getRandomId () : string {
    return `icon-${ Math.random().toString(36).slice(2, 10) }-${ Date.now() }`;
  }

  private _makeIconUnique ( rawSvg : string ) : string {
    const map    = new Map<string, string>();
    const prefix = this._getRandomId();

    for ( const match of rawSvg.matchAll(/\sid="([^"]+)"/g) ) {
      map.set(match[1], `${ prefix }-${ match[1] }`);
    }

    let svg = rawSvg;

    for ( const [ oldId, newId ] of map ) {
      const oldRef = oldId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      svg = svg
        .replace(new RegExp(`id="${ oldRef }"`, 'g'), `id="${ newId }"`)
        .replace(new RegExp(`url\\(#${ oldRef }\\)`, 'g'), `url(#${ newId })`)
        .replace(new RegExp(`href="#${ oldRef }"`, 'g'), `href="#${ newId }"`)
        .replace(new RegExp(`xlink:href="#${ oldRef }"`, 'g'), `xlink:href="#${ newId }"`);
    }

    return svg;
  }

  private _updateIcon () : void {
    if (this.icon && this.isTheme('inline')) {
      if ( typeof this.icon === 'string' ) {
        this.icon = this._makeIconUnique(this.icon);
      }

      this.icon = this.sanitizer.bypassSecurityTrustHtml(this.icon as string);
    }
  }

  isExtraLargeIcon () : boolean {
    return this.size === 'x-lg';
  }

  isLargeIcon () : boolean {
    return this.size === 'lg';
  }

  isSmallIcon () : boolean {
    return this.size === 'sm';
  }

  isTheme ( theme : IconThemeModel = 'workshop' ) : boolean {
    return theme === this.theme;
  }
}
